import Vue from 'vue'

Vue.filter('number', (value) => {
  if (typeof value !== 'number') return ''
  return value.toLocaleString('de-CH', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
})
